export default __webpack_public_path__ + "static/media/FillSurvey.94d25aa9.svg";